import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { UserRole } from "../../../@types/userRole";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";
import { RootState } from "../../rootReducer";

export const findUserRoles = createAsyncThunk(
  "massiveDocumentCreate/findUserRoles",
  async (data, { rejectWithValue, getState }) => {
    const state = getState() as RootState;
    const userList = state.massiveDocumentCreate.userRole;
    let maxUpdate: number = 0;

    if (userList.length > 0) {
      const orderedList = [...userList].sort((a, b) => {
        if (a.updatedAt && b.updatedAt && a.updatedAt < b.updatedAt) {
          return -1;
        }
        if (a.updatedAt && b.updatedAt && a.updatedAt > b.updatedAt) {
          return 1;
        }
        return 0;
      });
      maxUpdate = orderedList[orderedList.length - 1].updatedAt!;
    }
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}userrole/get-reduce`, {
        params: {
          limit: 4000,
          from: maxUpdate,
          sourceOrganization: state.userAuthentication.user?.sourceOrganization,
          where: {
            sourceOrganization: state.userAuthentication.user?.sourceOrganization,
          },
        },
      });

      let newList = [...userList.filter((element: any) => element.enabled === true)];

      data.forEach((element: any) => {
        if (newList.find((el) => el.id === element.id)) {
          let user = newList.find((el) => el.id === element.id);
          const indexToUpdate = newList.indexOf(user!);
          newList.splice(indexToUpdate, 1);
          newList.push(element);
        } else {
          newList.push(element);
        }
      });

      return newList;
    } catch (error) {
      rejectWithValue(error);
      throw error;
    }
  }
);
